import { Footer } from '@zappyrent/hundop';
import { upperCase } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { vatNumber } from '../../shared/constants';

const ZappyRentFooter = (): JSX.Element | null => {
  const { locale } = useParams();
  const { t } = useTranslation(['documentsflow', 'navigation', 'errors']);

  const footerProps = {
    content: [
      {
        title: 'ZAPPYRENT',
        body: [
          {
            text: t('navigation:whoWeAre'),
            title: t('navigation:whoWeAre'),
            url: `${process.env.REACT_APP_SITE_URL}/${locale}/who/we/are`,
          },
          {
            text: t('navigation:workWithUs'),
            title: t('navigation:workWithUs'),
            url: `${process.env.REACT_APP_SITE_URL}/${locale}/careers`,
          },
          {
            text: t('navigation:pressRoom'),
            title: t('navigation:pressRoom'),
            url: `${process.env.REACT_APP_SITE_URL}/it/press`,
          },
        ],
        key: 'main',
      },
      {
        title: upperCase(t('navigation:tenant')),
        body: [
          {
            text: t('navigation:tenantsFAQ'),
            title: t('navigation:tenantsFAQ'),
            url: t('navigation:tenantsFAQLink'),
          },
        ],
        key: 'tenant',
      },
      {
        title: upperCase(t('navigation:landlord')),
        body: [
          {
            text: t('navigation:publishAListing'),
            title: t('navigation:publishAListing'),
            url: `${process.env.REACT_APP_SITE_URL}/it/pubblica-annuncio-gratis`,
          },
          {
            text: t('navigation:howToRentAHome'),
            title: t('navigation:howToRentAHome'),
            url: `${process.env.REACT_APP_SITE_URL}/it/come-affittare-casa`,
          },
          {
            text: t('navigation:landlordsFAQ'),
            title: t('navigation:landlordsFAQ'),
            url: t('navigation:landlordsFAQLink'),
          },
          {
            text: t('navigation:protezioneZappyrent'),
            title: t('navigation:protezioneZappyrent'),
            url: `${process.env.REACT_APP_SITE_URL}/it/protezione-zappyrent`,
          },
          {
            text: t('navigation:rentsBlog'),
            title: t('navigation:rentsBlog'),
            url: `${process.env.REACT_APP_SITE_URL}/it/blog`,
          },
        ],
        key: 'landlord',
      },
    ],
    cookiePolicyLink: `${process.env.REACT_APP_SITE_URL}/${locale}/privacy/cookie`,
    termsAndConditionsLink: `${process.env.REACT_APP_SITE_URL}/${locale}/terms/conditions`,
    privacyPolicyLink: `${process.env.REACT_APP_SITE_URL}/${locale}/privacy/policy`,
    labels: {
      emailAddress: '',
      contactUs: upperCase(t('navigation:contactUs')),
      ask: 'Richiedi aiuto',
      termsAndConditions: t('navigation:termsAndConditions'),
      vat: t('miscellaneous:vat'),
      vatNumber,
    },
  };

  return <Footer {...footerProps} />;
};

export default ZappyRentFooter;
